import { render, staticRenderFns } from "./KeyValuesAdd.vue?vue&type=template&id=175ca73a&scoped=true"
import script from "./KeyValuesAdd.vue?vue&type=script&lang=js"
export * from "./KeyValuesAdd.vue?vue&type=script&lang=js"
import style0 from "./KeyValuesAdd.vue?vue&type=style&index=0&id=175ca73a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175ca73a",
  null
  
)

export default component.exports